export default "__VITE_ASSET__DxmBQDOZ__"